import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterProduct'
})
export class FilterProductPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter(it => {
      // let invoice_num = it.invoice_num == null ? "" : it.invoice_num;
      // // let prod_order_id = it.prod_order_id == null ? "" : it.prod_order_id;
      // let prod_order_id = String(it.prod_order_id);
      return it.product_name.toLowerCase().includes(searchText.toLowerCase()) ;
    });
  }

}
